import React from "react";
import BannerImage from "./BannerImage";
import ShikshaModel from "../shiksha-model.svg";
import "../../index.css";
import { InView } from "react-intersection-observer";

const WorkingModelContent = ({ node, currentLanguage }) => {
  const {
    title,
    body,
    bannerImage,
    workingModelPointsSecti,
    workingModelTableSectio,
  } = node;

  const colors = ["border-color-1", "border-color-2", "border-color-3"];
  const bg_colors = ["bg-color-1", "bg-color-2", "bg-color-3"];
  const textColors = ["text-color-1", "text-color-2", "text-color-3"];

  return (
    <section>
      <div className="relative z-0">
        <BannerImage imageUrl={bannerImage.url} />
        <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
          <h1 className="text-2xl sm:text-xl lg:text-3xl font-heading font-bold uppercase relative text-indian-red text-center section-heading">
            {title}
            <div className="relative flex items-center justify-center line-with-image">
              <img
                src="/assets/SHIKSHA_Flower_SVG.svg"
                alt="headingflower"
                className="h-7 sm:h-6 lg:h-9 p-1 sm:p-2"
              />
            </div>
          </h1>
          <div className="mt-4 sm:mt-6 md:mt-6 lg:mt-2 pb-8">
            <div
              className="text-sm sm:text-base md:text-base font-body lg:text-[15px] text-center mt-1"
              dangerouslySetInnerHTML={{ __html: body.value }}
            />
            <div className="text-center mobileview pt-40 relative">
              <div className="w-full flex justify-center items-center">
                <InView triggerOnce>
                  {({ inView, ref }) => (
                    <figure
                      ref={ref}
                      className={`relative animate-zoomIn ${
                        inView ? "visible" : ""
                      }`}
                    >
                      <img
                        className="w-full"
                        src={ShikshaModel}
                        alt="Shiksha Model"
                      />
                      <figcaption className="absolute top-1/2 font-heading left-0 w-full transform -translate-y-1/2 text-4xl text-black font-bold">
                        SHIKSHA <br /> MODEL
                      </figcaption>
                    </figure>
                  )}
                </InView>
              </div>
              {workingModelPointsSecti && workingModelPointsSecti.length > 0 ? (
                workingModelPointsSecti.map((paragraph, index) => {
                  const delay = (index + 1) * 500;
                  let animationClass = "";
                  let positionClass = "";

                  if (index % 3 === 0) {
                    animationClass = `animate-fadeInUp delay-${delay}`;
                    positionClass = " md:absolute md:top-0 md:left-0 md:w-full";
                  } else if (index % 3 === 1) {
                    animationClass = `animate-fadeInLeft delay-${delay}`;
                    positionClass =
                      " md:absolute md:top-[185px] md:right-0 md:w-[30%] md:text-left";
                  } else if (index % 3 === 2) {
                    animationClass = `animate-fadeInRight delay-${delay}`;
                    positionClass =
                      "md:absolute md:top-[185px] md:left-0 md:w-[30%] md:text-left";
                  }

                  const textColorClass = textColors[index % textColors.length];

                  const paragraphFirst =
                    index === 0 ? "max-w-[600px] inline-block" : "";
                  return (
                    <InView key={paragraph.id} triggerOnce>
                      {({ inView, ref }) => (
                        <div
                          ref={ref}
                          className={`mb-6 visible ${
                            inView ? animationClass : ""
                          } ${positionClass}`}
                        >
                          <div className={`mb-4`}>
                            <h3
                              className={`text-lg sm:text-xl font-heading md:text-xl lg:text-2xl leading-normal tracking-tight mb-1 font-bold ${textColorClass}`}
                            >
                              {paragraph.iconWithWorkingModelPo?.url && (
                                <img
                                  src={paragraph.iconWithWorkingModelPo.url}
                                  alt={paragraph.pointsTitle}
                                  className="w-8 mr-2 inline"
                                />
                              )}
                              {paragraph.pointsTitle}
                            </h3>
                          </div>
                          <p
                            className={`text-sm sm:text-base font-body md:text-base lg:text-[15px] ${paragraphFirst}`}
                          >
                            {paragraph.pointsDescription}
                          </p>
                        </div>
                      )}
                    </InView>
                  );
                })
              ) : (
                <p>No details available.</p>
              )}
            </div>
          </div>
        </div>
        <div className="bg-gray-300">
          <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
            <div className="flex flex-wrap pt-14">
              {workingModelTableSectio && workingModelTableSectio.length > 0 ? (
                workingModelTableSectio.map((tableSection, index) => (
                  <div key={tableSection.id} className={`md:w-1/3 mb-5 px-3`}>
                    <div
                      className={`border rounded-t-md h-full ${
                        colors[index % colors.length]
                      }`}
                    >
                      <h3
                        className={`text-center text-white font-heading text-xl mb-5 p-2.5 rounded-t-md uppercase ${
                          bg_colors[index % bg_colors.length]
                        }`}
                      >
                        {tableSection.tableTitle}
                      </h3>
                      <ul className="px-3 font-body">
                        {tableSection.tablePoints.map((point, idx) => (
                          <li
                            key={idx}
                            className={`py-1 text-base ${
                              idx === tableSection.tablePoints.length - 1
                                ? ""
                                : "border-b"
                            } ${colors[idx % colors.length]}`}
                          >
                            {point}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))
              ) : (
                <p>No details available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkingModelContent;
